import { useTranslate } from '@tolgee/react';
import React, { useEffect, useRef, useState } from 'react';
import { ToggleButton, ToggleButtonGroup } from 'react-bootstrap';
import Planning from './Planning';
import RecurringPosts from './RecurringPosts';
import { VIEW_STATUS } from '../../../config/constants';
import RecurrenceConfirmation from '../../../cards/recurrenceConfirmation';
import { useDispatch, useSelector } from 'react-redux';
import { lomavisCreatorRootState } from '../../../../../pages/lomavisCreator';
import { clearPublicationDateTime } from '../../../../../redux/slices/lomavisCreator/lomavisCreator';
import { ALL } from '../../../../../config/constants';
import PublishingDelay from './PublishingDelay';
import UpgradeRequiredTooltipWrapper from "../../../../utils/billing/UpgradeRequiredTooltipWrapper";

const LeftScheduling = ({ setCurrentViewDisplayed, currentViewDisplayed }) => {
  const { t } = useTranslate();
  const dispatch = useDispatch();

  const publicationDelay = useSelector(
    (state: lomavisCreatorRootState) =>
      state.lomavisCreator.schedulePlanningData.publication_delay_in_minutes
  );

  const temp_recurrence = useSelector(
    (state: lomavisCreatorRootState) =>
      state.lomavisCreator.schedulePlanningData.recurrence_as_str
  );

  const main_recurrence = useSelector(
    (state: lomavisCreatorRootState) => state.lomavisCreator.recurrence_as_str
  );

  const is_MultiPost = useSelector(
    (state: lomavisCreatorRootState) => state.lomavisCreator.is_multipost
  );

  const {
    lomavisCreatorConfig
  } = useSelector(
    (state: lomavisCreatorRootState) => state.lomavisCreator
  );


  const [show, setShow] = useState(false);

  const handleClose = () => {
    setShow(false);
  };
  const handleShow = () => setShow(true);
  const buttonRef = useRef(null);

  useEffect(() => {
    if (temp_recurrence || main_recurrence) {
      setCurrentViewDisplayed(VIEW_STATUS.RECURRING_POSTS);
    }
  }, []);

  return (
    <div className="w-100 d-flex flex-column gap-5 justify-content-between position-relative flex-fill h-100 ">
      <div className="w-100 d-flex flex-column gap-5 h-100">
        <div
          style={{ height: '50px' }}
          className="d-flex justify-content-start align-items-center flex-wrap my-4 flex-fill "
        >
          <div id="firstToggleButtonGroup">
            <div className="btn-group">
              <button
                type="button"
                className={`btn btn-secondary btn-sm d-flex justify-content-center align-items-center ${
                  currentViewDisplayed === VIEW_STATUS.PLANNING ? 'active' : ''
                }`}
                onClick={() =>
                  publicationDelay || temp_recurrence
                    ? buttonRef.current.click()
                    : setCurrentViewDisplayed(VIEW_STATUS.PLANNING)
                }
              >
                <i className="fa-duotone fa-calendar-days"></i>
                {t('lomavisCreator.planningSlide.planning')}
              </button>
              {!is_MultiPost && (
                  <UpgradeRequiredTooltipWrapper show={!lomavisCreatorConfig.features.recurring_posts}>
                <button
                  type="button"
                  className={`btn btn-secondary btn-sm d-flex justify-content-center align-items-center ${
                    currentViewDisplayed === VIEW_STATUS.RECURRING_POSTS
                      ? 'active'
                      : ''
                  }`}
                  onClick={() => {
                    dispatch(clearPublicationDateTime({ platform: ALL }));
                    setCurrentViewDisplayed(VIEW_STATUS.RECURRING_POSTS);
                  }}
                >
                  <i className="fa-duotone fa-repeat"></i>
                  {t('lomavisCreator.planningSlide.recurring_posts')}
                </button>
                    </UpgradeRequiredTooltipWrapper>
              )}

              {is_MultiPost && (

                    <button
                        type="button"
                        className={`btn btn-secondary btn-sm d-flex justify-content-center align-items-center ${
                            currentViewDisplayed === VIEW_STATUS.DELAY ? 'active' : ''
                        }`}
                        onClick={() => {
                          setCurrentViewDisplayed(VIEW_STATUS.DELAY);
                        }}
                    >
                      <i className="fa-duotone fa-solid fa-clock"></i>
                      {t('lomavisCreator.planningSlide.delay')}
                    </button>
              )}
            </div>
          </div>
        </div>
        <button
          type="button"
          className="btn btn-primary d-none"
          onClick={handleShow}
          ref={buttonRef}
        >
          Launch demo modal
        </button>
        <RecurrenceConfirmation
          handleClose={handleClose}
          handleShow={handleClose}
          setCurrentViewDisplayed={setCurrentViewDisplayed}
          show={show}
        />
        <div
          style={{ overflowY: 'scroll' }}
          className="d-flex flex-column gap-3 flex-fill h-100 "
        >
          {currentViewDisplayed === VIEW_STATUS.PLANNING ? (
            <Planning />
          ) : currentViewDisplayed === VIEW_STATUS.RECURRING_POSTS ? (
            <RecurringPosts />
          ) : (
            <PublishingDelay />
          )}
        </div>{' '}
      </div>
    </div>
  );
};

export default LeftScheduling;
